import React from 'react';

interface KeywordChipProps {
  keyword: string;
  className?: string;
}

const KeywordChip: React.FC<KeywordChipProps> = ({ keyword, className = '' }) => {
  return (
    <span
      className={`inline-flex items-center rounded-[2px] px-2 py-0.5 text-[11px] font-medium text-white border border-gray-500 ${className}`}
    >
      {keyword}
    </span>
  );
};

export default KeywordChip;
